import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaRocket, FaEnvelope, FaArrowRight, FaQuoteLeft, FaStar, FaUserCircle } from 'react-icons/fa';
import appData from '../data/data';

export default function Home(){
  const navigate = useNavigate();

  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) entry.target.classList.add('visible');
      });
    }, { threshold: 0.1 });
    document.querySelectorAll('.fade-in').forEach(el => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <div>
      <section className="hero">
        <div className="floating-shape" />
        <div className="floating-shape" />
        <div className="floating-shape" />
        <div className="hero-content">
          <div className="hero-badge"><FaRocket/> <span>Leading Tech & Non-Tech Solutions</span></div>
          <h1>From Code To Commerce</h1>
          <p>We've Got You Covered - Comprehensive tech and non-tech solutions that drive business growth and innovation</p>
          <div className="cta-buttons">
            <button className="btn btn-primary" onClick={() => navigate('/services')}><FaArrowRight/> Explore Services</button>
            <button className="btn btn-secondary" onClick={() => navigate('/contact')}><FaEnvelope/> Contact Us</button>
          </div>
        </div>
      </section>

      <section className="section">
        <h2 className="section-title fade-in">Why Choose Syntax2Scale?</h2>
        <p className="section-subtitle fade-in">We deliver comprehensive solutions that combine technical excellence with business acumen</p>
        <div className="card-grid-3">
          {appData.features.map((f, idx) => (
            <div key={idx} className="card fade-in" style={{ animationDelay: `${idx * .1}s` }}>
              <div className="card-icon"><f.Icon/></div>
              <h3 className="card-title">{f.title}</h3>
              <p className="card-description">{f.description}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="section testimonials-section">
        <h2 className="section-title fade-in">What Our Clients Say</h2>
        <p className="section-subtitle fade-in">Don't just take our word for it - hear from businesses we've helped transform</p>
        <div className="testimonials-grid">
          {appData.testimonials.map((t, idx) => (
            <div key={t.id} className="testimonial-card fade-in" style={{ animationDelay: `${idx*.1}s` }}>
              <div className="testimonial-quote-icon"><FaQuoteLeft/></div>
              <div className="testimonial-stars">
                {Array(t.rating).fill(null).map((_, i) => <FaStar key={i} />)}
              </div>
              <p className="testimonial-message">{t.message}</p>
              <div className="testimonial-author">
                <div className="testimonial-avatar"><FaUserCircle/></div>
                <div className="testimonial-info">
                  <h4 className="testimonial-name">{t.name}</h4>
                  <p className="testimonial-designation">{t.designation}</p>
                  <p className="testimonial-company">{t.company}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
